<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    <span class="link-a cur-p" @click="back()">
                        RETURN PARTS</span
                    >
                    / PRINT
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right ">
                <v-btn rounded small @click="print()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print {{ types }}</v-btn
                >
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" id="printLCD" v-if="types == 'LCD'">
                <div
                    :style="
                        'background-image: url(' +
                            url_pic +
                            'LCDReturnTAG.jpg' +
                            ');height: 100%; background-repeat: no-repeat; background-position: center center; background-size: cover; text-align: center;'
                    "
                >
                    <v-row>
                        <v-col
                            style="color: #333; font-size: 120%; display: inline-block; margin-top: 350px; padding: 0px;"
                            cols="12"
                        >
                            <span style="margin-left:-15px;">{{
                                data_main.product_serial
                            }}</span>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
            <v-col cols="12" id="printMB" v-if="types == 'MB'">
                <div
                    :style="
                        'background-image: url(' +
                            url_pic +
                            'MBReturnTAG.jpg' +
                            ');height: 100%; background-repeat: no-repeat; background-position: center center; background-size: cover; text-align: center;'
                    "
                >
                    <v-row>
                        <v-col
                            style="color: #333; font-size: 85%; display: inline-block; margin-top: 224px; padding: 0px;"
                            cols="4"
                        >
                            <span style="margin-left:5px;">{{
                                data_main.branch_name
                            }}</span>
                        </v-col>
                        <v-col
                            style="color: #333; font-size: 85%; display: inline-block; margin-top: 224px; padding: 0px;"
                            cols="2"
                        >
                            <span style="margin-left:-130px;">{{
                                data_main.case_id
                            }}</span>
                        </v-col>
                        <v-col
                            style="color: #333; font-size: 85%; display: inline-block; margin-top: 224px; padding: 0px;"
                            cols="2"
                        >
                            <span style="margin-left:-80px;">{{
                                data_main.onsite_date
                            }}</span>
                        </v-col>
                        <v-col
                            style="color: #333; font-size: 85%; display: inline-block; margin-top: 224px; padding: 0px;"
                            cols="2"
                        >
                            <span style="margin-left:55px;color:#FFF;">xx</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                            style="color: #333; font-size: 85%; display: inline-block; margin-top: 30px; padding: 0px;"
                            cols="4"
                        >
                            <span style="margin-left:5px;">{{
                                data_main.product_serial
                            }}</span>
                        </v-col>
                        <v-col
                            style="color: #333; font-size: 85%; display: inline-block; margin-top: 30px; padding: 0px;"
                            cols="2"
                        >
                            <span style="margin-left:-130px;">{{
                                data_main.part_name
                            }}</span>
                        </v-col>
                        <v-col
                            style="color: #333; font-size: 85%; display: inline-block; margin-top: 30px; padding: 0px;"
                            cols="2"
                        >
                            <span style="margin-left:-20px;">{{
                                data_main.rma
                            }}</span>
                        </v-col>
                        <v-col
                            style="color: #333; font-size: 85%; display: inline-block; margin-top: 30px; padding: 0px;"
                            cols="2"
                        >
                            <span style="margin-left:0px;">{{
                                data_main.ct_new
                            }}</span>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    mounted() {
        this.get_data()
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            this.mutateIsLoading()
            await axios
                .get(url + "engineer/return-part-view/" + this.part_issue_id)
                .then((response) => {
                    this.data_main = response.data
                    setTimeout(() => {
                        this.print()
                    }, 1500)
                    this.mutateIsLoading()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        back() {
            if (this.role_type == "Engineer") {
                this.$router.push("/Onsite/Main/Return-Part")
            } else {
                this.$router.push("/Return-Part")
            }
        },
        print() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://aitt.netlify.app/barcode.css",
                ],
            }
            let p
            this.types == "LCD" ? (p = "printLCD") : (p = "printMB")
            this.$htmlToPaper(p, localOptions, () => {})
        },
    },
    data() {
        return {
            part_issue_id: this.$route.params.part_issue_id,
            types: this.$route.params.type,
            data_main: [],
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/form-images/`,
            role_type: localStorage.role_type,
        }
    },
}
</script>
